import { Middleware } from 'redux'
import { createLogger } from 'redux-logger'

import { getEnvironment } from '../platform/functions'
import { Environment } from '../../common/api/types'

export const loggerMiddleware: Middleware = createLogger({ predicate: () => getEnvironment() !== Environment.PRODUCTION })